module.exports = __webpack_public_path__ + "images/emoji/rage1.99af14cd4602ac04b9f1.png";